export const richPresenceDetails = [
    'Stealing all the wheat',
    'Gathering resources',
    'Building the longest road',
    'Taking over the island',
    'Stealing all the brick',
    'Buying development cards',
    'Losing friends, gaining points',
    'Cornering the ore market',
    'Making bad decisions',
    'Hoarding sheep'
];
export const richPresenceStates = [
    'Come Play!'
];
